<div class="sb-loading-spinner-container"
    [attr.data-sb-qa]="qaTag()"
    [class.sb-loading-spinner-container--inline]="!fullPage()"
    [class.sb-loading-spinner-container--nav-closed]="fullPage() && !Scope.sideNavOpen?.() && !isTouchScreenDevice"
    [class.sb-loading-spinner-container--nav-open]="fullPage() && Scope.sideNavOpen?.() && !isTouchScreenDevice">
    <div class="sb-loading-spinner"></div>
</div>
